import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";
import { ImgRoute } from "contents/Images";

export const AVERAGE = () => {
  return (
    <CardSection id="AVERAGE" title="AVERAGE">
      <Paragraph>
        숫자 목록의 합을 목록의 항목 수로 나눈 값을 계산합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>AVERAGE(VALUE_1, [VALUE_2, ...])</Paragraph>
        <Ul>
          <Li>
            <b>VALUE_1</b>은 첫 번째 값입니다.
          </Li>
          <Li>
            <b>VALUE_2, ... [선택 사항]</b>은 추가 값입니다.
          </Li>
        </Ul>
      </ListSection>
      <ListSection title="Example">
        <Paragraph accent>
          AVERAGE(`Column_A`, `Column_B`, `Column_C`)
        </Paragraph>
        <Img src="computeAverage" />
      </ListSection>
      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>VALUE</b>는 숫자 값, 숫자 값이 포함된 열 또는 숫자 값을
          반환하는 함수여야 합니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
